import "./OurProcess.module.css";
import Header from "@/reusable_sections/Header";
import OurApproach from "./sections/OurApproach";
import ServiceOfferings from "./sections/ServiceOfferings";
import Footer from "@/reusable_sections/Footer";
export default function OurProcessPage() {
  return <div>
      <Header />
      <OurApproach />
      <ServiceOfferings />
      <Footer />
    </div>;
}